<template>
  <div class="amp_main">
    <div class="umlaut_con" v-loading="loading">
      <div class="flex_bet_h tools_titmod">
        <span class="tools_tit">音频变音</span>
        <img
          src="../../assets/images/img2/offlogin.png"
          class="tools_off"
          @click="hide"
        />
      </div>
      <div class="umlaut_sel flex_bet">
        <div class="flex_ali" v-if="url">
          <img
            src="../../assets/images/pause.png"
            class="audio_selliplay umlaut_play"
            v-if="audio.audiourl == url"
            @click="audio.play(url)"
          />
          <img
            src="../../assets/images/play.png"
            class="audio_selliplay umlaut_play"
            v-else
            @click="audio.play(url)"
          />
          <div>
            <p class="overflow_hide">{{ wkname ? wkname : "未命名作品" }}</p>
            <p class="joint_mod_text joint_mod_text1">
              <span>{{ anchor ? anchor : "无主播" }}</span>
              <span>{{ bgname ? bgname : "无背景音" }}</span>
            </p>
          </div>
        </div>
        <div v-else>未选择音频</div>
        <div class="umlaut_selbtn" @click="seAudio">
          {{ url ? "更换音频" : "选择音频" }}
        </div>
      </div>
      <p class="umlaut_tit">变声特效</p>
      <div class="umlaut_list">
        <div
          class="umlaut_li"
          v-for="(item, index) in soundList"
          :key="index"
          @click="setUmlayut(item)"
        >
          <div class="umlaut_liimg">
            <img :src="item.image" class="umlaut_li_img" />
            <div class="umlaut_li_mb" v-if="umlaut_type == item.type">
              <img src="../../assets/images/img2/duigou.png" />
            </div>
          </div>
          <p>{{ item.name }}</p>
        </div>
      </div>
      <div class="flex_bet_h">
        <div
          class="tools_btn"
          @click="getUmlautAudio(false)"
          v-if="!play_state"
        >
          <img src="../../assets/images/play.png" class="tools_btn_icon" />
          <span>试听效果</span>
        </div>
        <div class="tools_btn" @click="stopPlay" v-else>
          <img src="../../assets/images/pause.png" class="tools_btn_icon" />
          <span>暂停播放</span>
        </div>
        <div class="tools_btn tools_btn2" @click="qryApiLimit(true)">
          <img
            src="../../assets/images/img2/exfile.png"
            class="tools_btn_icon"
          />
          <span>导出音频</span>
        </div>
      </div>
    </div>
    <audioLiist v-if="show_list" @hide="show_list = false" @setWork="setWork" />
  </div>
</template>
<script>
// 选择音频组件
import audioLiist from "./audio_list.vue";
import PlayListAudio from "../../utils/PlayListAudio.js";
export default {
  components: {
    audioLiist,
  },
  data() {
    return {
      show_list: false, //选择音频组件显示状态
      url: "", //选择音频url
      wkname: "", //选择音频名称
      anchor: "", //选择音频主播
      bgname: "", //选择音频背景音名称
      soundList: [], //特效列表
      loading: false, //加载动画显示状态
      umlaut_type: 0, //特效类型
      audio: new PlayListAudio(),
      audio2: new Audio(), //播放器
      play_state: false, //播放状态
      time: null,
    };
  },
  mounted() {
    this.getUmlautList();
  },
  methods: {
    // 停止播放
    stopPlay() {
      this.audio2.pause();
      this.play_state = false;
    },
    // 监听播放状态
    monitorPlay() {
      let self = this;
      this.time = setInterval(() => {
        if (self.audio2.ended) {
          self.play_state = false;
          clearInterval(self.time);
        }
      }, 1000);
    },
    // 查询接口调用次数
    qryApiLimit(isextend) {
      this.$globalFun.qryApiLimit(this,'1',()=>{
        this.getUmlautAudio(isextend)
      })
    },
    // 更新api使用剩余次数
    uptApiLimit: function() {
      this.$globalFun.uptApiLimit(this,'1')
    },
    // 开始变音
    getUmlautAudio(isextend) {
      // isextend？true=导出音频：false=试听效果
      let self = this;
      if (this.url == "") {
        this.$message({
          message: "请选择需要变音的音频",
          type: "warning",
        });
        return;
      }
      // 选择原音直接返回原音频
      if (this.umlaut_type == "0") {
        this.playorextendAudio(isextend, this.url);
        return;
      }
      let url =
        self.$store.state.app_api + self.$store.state.app_url.changesoundapp;
      let json = {
        mp3url: this.url,
        type: this.umlaut_type,
      };
      this.loading = true;
      this.$request.postHttp(json, url, (decData) => {
        self.loading = false;
        this.$globalFun.uptApiLimit(this,'1')
        self.playorextendAudio(isextend, decData.model.mp3url);
      });
    },
    // 试听/导出音频
    playorextendAudio(isextend, mp3url) {
      if (!isextend) {
        this.audio2.src = mp3url;
        this.audio2.play();
        this.play_state = true;
        this.monitorPlay();
      } else {
        this.$globalFun.downloadDub(mp3url);
      }
    },
    // 选择变声特效
    setUmlayut(item) {
      this.umlaut_type = item.type;
    },
    // 选择/更换音频
    seAudio() {
      this.show_list = true;
      this.audio.stop();
    },
    // 选择作品
    setWork(e) {
      this.show_list = false;
      this.url = e.musicpath;
      this.wkname = e.wkname;
      this.bgname = e.bgname;
      this.anchor = e.voiceauthor;
    },
    // 获取变音特效列表
    getUmlautList() {
      let self = this;
      let url = self.$store.state.app_api + self.$store.state.app_url.qrylist;
      this.$request.postHttp({}, url, (decData) => {
        console.log(decData);
        self.soundList = decData.model.soundList;
      });
    },
    hide() {
      this.$emit("hide");
    },
  },
};
</script>

<style scoped>
@import url("../../assets/css/tools.css");
</style>


// WEBPACK FOOTER //
// src/components/tools/umlaut.vue